import MainLayout from "@/components/layout/admin/MainLayout.vue";
import TwspNameJson from "@/assets/json/township.json";
import RegionJson from "@/assets/json/region.json";
import {
    required,
    email,
    maxLength,
    minLength,
    numeric
} from "vuelidate/lib/validators";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "companyUpdate",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            isEditForm: true,
            submitted: false,
            company_logo: "",
            company: {
                company_logo: "",
                company_name: "",
                email: "",
                phone_number: "",
                address: "",
                town: "",
                region: "",
                company_detail: "",
                agency: ""
            },
            oldRegion: "",
            error_email: "",
            regionArr: RegionJson,
            selectedTwspName: "",
            twspNameJson: TwspNameJson,
            twspName: []
        };
    },

    validations: {
        company: {
            company_name: {
                required,
                maxLength: maxLength(100)
            },
            email: {
                // required,
                email
            },
            phone_number: {
                minLength: minLength(9),
                maxLength: maxLength(11),
                numeric
            },
            region: {
                required
            }
        }
    },

    methods: {
        onChange(event) {
            var Value = event.target.value;
            this.company.region = Value;
            this.selectedTwspName = "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.company.town = Value;
        },

        onProfileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return null;
            this.company_logo = e.target.files[0];
            let reader = new FileReader();
            reader.onload = e => {
                this.company_logo = e.target.result;
                this.company.path = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },

        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.updateCompany();
        },

        showCompanyUpdate() {
            axios.get("/company/update/" + this.$route.params.id)
                .then(response => {
                    this.company = response.data;
                    this.oldRegion = response.data.region;
                    this.twspName = this.changeTwspName(this.company.region);
                })
                .catch(error => {
                    console.log("Company Update API Error", error);
                });
        },

        updateCompany() {
            this.isLoading = true;
            var request = {
                id: this.company.id,
                company_name: this.company.company_name,
                email: this.company.email,
                phone_number: this.company.phone_number,
                address: this.company.address,
                town: this.company.town,
                region: this.company.region,
                company_detail: this.company.company_detail,
                agency: this.company.agency
            };

            if (this.company_logo.length < 10000000) {
                request.company_logo = this.company_logo;
                request.old_company_logo = this.company.company_logo;
            } else {
                request.company_logo = null;
                request.old_company_logo = null;
            }

            axios.post("/company/updated", request)
                .then(response=> {
                    if (response.data.img_error_msg) {
                        this.image_size = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("The upload image size is too large.", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else if (response.data.msg) {
                        this.error_email = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("Company Edit Failed", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.$notification.success("Company Edited Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.isLoading = false;
                        this.$router.push({
                            name: "companyList"
                        });
                    }
                })
                .catch(error => {
                    console.log("Edit Company Error", error);
                });
        }
    },

    created() {
        this.showCompanyUpdate();
    }
};
